import React, { useContext, useEffect, useRef, useState } from "react";
import { OutorgaContext } from "../../../../../contexts/Outorga";
import DefaultParams from "./Parameters/DefaultParams";
import CustomParams from "./Parameters/CustomParams";
import helper from "../../../../../utils/helper";

const Parameters = ({ grantId, permissions = {}, isMasterOrAdmin }) => {
    const context = useContext(OutorgaContext);
    const [openDefault, setOpenDefault] = useState(true);
    const [openCustom, setOpenCustom] = useState(true);
    const defaultParamsRef = useRef(null);
    const customParamsRef = useRef(null);

    const {
        getGrant,
        saveGrantDefaultParams,
        saveGrantCustomParams,
        isLoadingGrantDefaultParams,
        isLoadingGrantCustomParams
    } = context;

    const canEdit = isMasterOrAdmin || permissions.post || permissions.patch;

    useEffect(() => {
        getGrant(grantId);
    }, [grantId]);

    const toggleSection = (section) => {
        if (section === "openDefault") {
            setOpenDefault(prev => !prev);
        }
        if (section === "openCustom") {
            setOpenCustom(prev => !prev);
        }
    };

    const handleSaveParams = async () => {
        const defaultRef = defaultParamsRef.current;
        const customRef = customParamsRef.current;
        const {defaultIsValid} = defaultRef.validateParameters();
        const {customIsValid} = customRef.validateParameters();

        if (!defaultIsValid) {
            helper.dispatchEvent("showAviso", { message: "Existem parâmetros ativos com campos não preenchidos." });

            return;
        }

        if (!customIsValid) {
            helper.dispatchEvent("showAviso", { message: "Existem parâmetros com campos não preenchidos." });

            return;
        }

        const defaultParams = defaultRef && defaultRef.handleSave ? defaultRef.handleSave() : null;
        const customParams = customRef && customRef.handleSave ? customRef.handleSave() : null;

        if (defaultParams) {
            await saveGrantDefaultParams(grantId, defaultParams);
        }

        if (customParams) {
            await saveGrantCustomParams(grantId, customParams);
        }
    };

    return (
        <div className="hdv-form-default parameters-container">
            <div className="parameters-section">
                <div
                    className="parameters-header"
                    onClick={() => toggleSection("openDefault")}
                >
                    <span className={`parameters-arrow ${openDefault ? "open" : ""}`}>
                        <i className="fa fa-caret-right" />
                    </span>
                    <h5 className="grant-params__title">
                        Parâmetros de Outorga Padrão
                    </h5>
                </div>

                <div className={`parameters-content ${openDefault ? "open" : ""}`}>
                    <DefaultParams ref={defaultParamsRef} grantId={grantId} />
                </div>
            </div>

            <hr />

            <div className="parameters-section">
                <div
                    className="parameters-header"
                    onClick={() => toggleSection("openCustom")}
                >
                    <span className={`parameters-arrow ${openCustom ? "open" : ""}`}>
                        <i className="fa fa-caret-right" />
                    </span>
                    <h5 className="grant-params__title">
                        Parâmetros de Outorga Customizados
                    </h5>
                </div>

                <div className={`parameters-content ${openCustom ? "open" : ""}`}>
                    <CustomParams ref={customParamsRef} grantId={grantId} />
                </div>
            </div>

            <hr />

            <div className="grant-custom-params__save-btn">
                {canEdit && (
                    <button
                        onClick={handleSaveParams}
                        className="hdv-btn-forms hdv-btn-green"
                        disabled={isLoadingGrantDefaultParams || isLoadingGrantCustomParams}
                    >
                        Salvar
                    </button>
                )}
            </div>
        </div>
    );
};

export default Parameters;